import {EmailPurpose} from './types'

const TOKEN_KEY = 'selective_ai_reset_session_token'
const PURPOSE_KEY = 'selective_ai_reset_email_purpose'
const EMAIL_KEY = 'selective_ai_reset_email'
const USERNAME_KEY = 'selective_ai_reset_username'
const PENDING_ID_TOKEN_KEY = 'selective_ai_password_reset_id_token'

export function storeResetSession(
  resetSessionToken: string,
  emailPurpose: EmailPurpose,
  email: string,
  username: string
): void {
  try {
    sessionStorage.setItem(TOKEN_KEY, resetSessionToken)
    sessionStorage.setItem(PURPOSE_KEY, emailPurpose)
    sessionStorage.setItem(EMAIL_KEY, email)
    sessionStorage.setItem(USERNAME_KEY, username)
  } catch {
    // ignore storage errors
  }
}

export function readResetSession(): {
  resetSessionToken: string | null
  emailPurpose: EmailPurpose | null
  email: string | null
  username: string | null
} {
  try {
    const resetSessionToken = sessionStorage.getItem(TOKEN_KEY)
    const purpose = sessionStorage.getItem(PURPOSE_KEY)
    const emailPurpose = purpose === 'set' || purpose === 'reset' ? (purpose as EmailPurpose) : null
    return {
      resetSessionToken,
      emailPurpose,
      email: sessionStorage.getItem(EMAIL_KEY),
      username: sessionStorage.getItem(USERNAME_KEY),
    }
  } catch {
    return {resetSessionToken: null, emailPurpose: null, email: null, username: null}
  }
}

export function clearResetSession(): void {
  try {
    sessionStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(PURPOSE_KEY)
    sessionStorage.removeItem(EMAIL_KEY)
    sessionStorage.removeItem(USERNAME_KEY)
  } catch {
    // ignore storage errors
  }
}

export function storePendingGooglePasswordReset(idToken: string): void {
  try {
    sessionStorage.setItem(PENDING_ID_TOKEN_KEY, idToken)
  } catch {
    // ignore storage errors
  }
}

export function readPendingGooglePasswordReset(): {idToken: string | null} {
  try {
    return {
      idToken: sessionStorage.getItem(PENDING_ID_TOKEN_KEY),
    }
  } catch {
    return {idToken: null}
  }
}

export function clearPendingGooglePasswordReset(): void {
  try {
    sessionStorage.removeItem(PENDING_ID_TOKEN_KEY)
  } catch {
    // ignore storage errors
  }
}
